import * as c from "../actions/constants";
import * as storage from "../utils/storage";

const initialState = {
        searchText:''
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case c.SEARCH_ACTION:
            if( typeof action.payload.searchText !== 'undefined' )
            {
                console.log('%csearchBar action', 'color:green;background:yellow', action, state );
                let ret = { ...state, searchText: action.payload.searchText };
                console.log('%csearchBar action ---> ', 'color:green;background:yellow', action, state );
                return ret;
            }
            else
            {
                console.log('%cERROR! searchBar action', 'color:red;background:yellow', action );
                return state;
            }
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/searchBarReducer.js